// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://9rrg878b90.execute-api.eu-west-2.amazonaws.com/dev';
export const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN || 'clini-score-dev-227647310470.auth.eu-west-2.amazoncognito.com';
export const CLIENT_ID = import.meta.env.VITE_CLIENT_ID || 'tt0fk2n8or0vbo2kih4r60uuh';
export const MONTHLY_LIMIT = import.meta.env.VITE_MONTHLY_LIMIT || 10;

// Assessment Views
export const VIEWS = {
  HOME: 'home',
  PATIENT_LIST: 'patient-list',
  PATIENT_INITIALS: 'patient-initials',
  PRE_ANALYSIS: 'pre-analysis',
  PROCESSING: 'processing',
  POST_ANALYSIS: 'post-analysis'
};

// Assessment Categories
export const ASSESSMENT_CATEGORIES = [
  { prefix: 'selfcare_', title: 'SELF CARE', labelReplace: 'selfcare_' },
  { prefix: 'bladder_', title: 'BLADDER MANAGEMENT', labelReplace: 'bladder_' },
  { prefix: 'bowel_', title: 'BOWEL MANAGEMENT', labelReplace: 'bowel_' },
  { prefix: 'mobility_', title: 'MOBILITY', labelReplace: 'mobility_' },
  { prefix: 'locomotion_', title: 'LOCOMOTION', labelReplace: 'locomotion_' },
  { prefix: 'communication_', title: 'COMMUNICATION', labelReplace: 'communication_' },
  { prefix: 'psychosocial_', title: 'PSYCHOSOCIAL', labelReplace: 'psychosocial_' },
  { prefix: 'cognition_', title: 'COGNITION', labelReplace: 'cognition_' },
  { prefix: 'adl_', title: 'ACTIVITIES OF DAILY LIVING', labelReplace: 'adl_' }
];

// Polling Configuration
export const POLLING_CONFIG = {
  MAX_ATTEMPTS: 120, // Poll for up to 4 minutes (120 * 2 seconds)
  POLL_INTERVAL: 2000, // 2 seconds
  RETRY_INTERVAL: 3000, // 3 seconds on error
  MAX_RETRY_ATTEMPTS: 5
};

// Score Range
export const SCORE_RANGE = [1, 2, 3, 4, 5, 6, 7];

// Domain Order - matches backend prompt order exactly
export const DOMAIN_ORDER = [
  // Self Care (7 domains)
  'selfcare_eating',
  'selfcare_swallowing',
  'selfcare_grooming',
  'selfcare_bathing',
  'selfcare_dressing_upper',
  'selfcare_dressing_lower',
  'selfcare_toileting',
  // Bladder Management (2 domains)
  'bladder_level_of_assistance',
  'bladder_frequency_of_accidents',
  // Bowel Management (2 domains)
  'bowel_level_of_assistance',
  'bowel_frequency_of_accidents',
  // Mobility (4 domains)
  'mobility_bed_chair_wheelchair',
  'mobility_toilet',
  'mobility_tub_shower',
  'mobility_car',
  // Locomotion (3 domains)
  'locomotion_walking',
  'locomotion_wheelchair',
  'locomotion_stairs',
  // Mobility Community (1 domain)
  'mobility_community',
  // Communication (5 domains)
  'communication_comprehension',
  'communication_expression',
  'communication_reading',
  'communication_writing',
  'communication_speech_intelligibility',
  // Psychosocial (4 domains)
  'psychosocial_social_interaction',
  'psychosocial_emotional_status',
  'psychosocial_adjustment_to_limitations',
  'psychosocial_leisure_activities',
  // Cognition (5 domains)
  'cognition_problem_solving',
  'cognition_memory',
  'cognition_orientation',
  'cognition_concentration',
  'cognition_safety_awareness',
  // Activities of Daily Living (6 domains)
  'adl_meal_preparation',
  'adl_laundry',
  'adl_housework',
  'adl_work_edu',
  'adl_finances',
  'adl_shopping'
];

// Feedback Modal Trigger
export const FEEDBACK_THRESHOLD = 0.5; // Show when below 50% of monthly limit

